import { handleActions } from 'redux-actions';
import UPDATE_APPLICATION_NAME from 'ui-forms-editor-automation-lib/constants/actions/UPDATE_APPLICATION_NAME';
import APPLICATION_NAMES from 'ui-forms-editor-automation-lib/constants/APPLICATION_NAMES';
export const INITIAL_STATE = {
  applicationName: APPLICATION_NAMES.FORMSUI
};
export default handleActions({
  [UPDATE_APPLICATION_NAME]: (_, {
    payload
  }) => ({
    applicationName: payload
  })
}, INITIAL_STATE);